import {MeasureSystemType} from "../types/domain/measureSystemType";
import {MeasureUnitType} from "../types/domain/measureUnitType";
import {EnumItem} from "../types/enumItem";
import {
    cToF,
    haToAcre,
    kgByhaToLbByAcre,
    meterPerSecondToMilePerHour,
    mmToInch,
    cmCubeToInchByFoot,
} from "./measureSystemConversionsUtils";
import {MeasureSystemUtils} from "../types/domain/measureSystemUtils";
import {Field} from "../types/domain/field";

/**
 * Values from the backend are returned in metric system.
 */
export const getMeasureSystemUtilsClosure = (
    measureUnits: Record<string, EnumItem>,
    ms: MeasureSystemType,
): MeasureSystemUtils => ({
    getAreaUnits: () =>
        ms === MeasureSystemType.IMPERIAL
            ? measureUnits[MeasureUnitType.ACRE].label
            : measureUnits[MeasureUnitType.HECTARE].label,
    getWindSpeedUnits: () =>
        ms === MeasureSystemType.IMPERIAL
            ? measureUnits[MeasureUnitType.MILE_PER_HOUR].label
            : measureUnits[MeasureUnitType.METER_PER_SECOND].label,
    getRainfallUnits: () =>
        ms === MeasureSystemType.IMPERIAL
            ? measureUnits[MeasureUnitType.INCH].label
            : measureUnits[MeasureUnitType.MM].label,
    getTemperatureUnits: () => (ms === MeasureSystemType.IMPERIAL ? "\u2109" : "\u2103"),
    getProductionUnits: () =>
        ms === MeasureSystemType.IMPERIAL
            ? measureUnits[MeasureUnitType.LB_PER_ACRE].label
            : measureUnits[MeasureUnitType.KG_PER_HECTARE].label,
    getDistanceUnits: () =>
        ms === MeasureSystemType.IMPERIAL
            ? measureUnits[MeasureUnitType.FOOT].label
            : measureUnits[MeasureUnitType.METER].label,
    getMoistureUnits: () =>
        ms === MeasureSystemType.IMPERIAL
            ? `${measureUnits[MeasureUnitType.INCH].label}/${measureUnits[MeasureUnitType.FOOT].label}`
            : `${measureUnits[MeasureUnitType.METER].label}\u00B3/${measureUnits[MeasureUnitType.METER].label}\u00B3`,

    getArea: (value: number): number => (ms === MeasureSystemType.IMPERIAL ? haToAcre(value) : value),
    getRainfall: (value: number): number => (ms === MeasureSystemType.IMPERIAL ? mmToInch(value) : value),
    getTemperature: (value: number): number => (ms === MeasureSystemType.IMPERIAL ? cToF(value) : value),
    getWindSpeed: (value: number): number =>
        ms === MeasureSystemType.IMPERIAL ? meterPerSecondToMilePerHour(value) : value,
    getProduction: (value: number): number => (ms === MeasureSystemType.IMPERIAL ? kgByhaToLbByAcre(value) : value),
    getMoisture: (value: number): number => (ms === MeasureSystemType.IMPERIAL ? cmCubeToInchByFoot(value) : value),
});

export const getFieldAreaFormatted = (field: Field | undefined, ms: MeasureSystemUtils): string =>
    field?.areaInHa ? ms.getArea(field.areaInHa).toFixed(2) : "N/A";
